import {
  ApiResponse
} from "@/types";
import {
  IncomeCategoryTable,
  IncomeCategory as IncomeCategoryType,
} from "@/types/system-setting/income-category";

import { apiSlice } from "@/redux/apiSlice";

export const IncomeCategory = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      getIncomeCategory: builder.query<
        IncomeCategoryTable,
        { query: string; org_id: number; revenue_type?: 'donation' | 'income' }
      >({
        query: (searchCretiria) => {
          let queryString = searchCretiria.query;
          if (searchCretiria.revenue_type) {
            queryString += (queryString ? '&' : '') + `revenue_type=${searchCretiria.revenue_type}`;
          }
          return {
            url: `/income_category?org_id=${searchCretiria.org_id}&${queryString}`,
            method: "GET",
            headers: {
              Accept: "application/json",
            },
          };
        },
        providesTags: ["IncomeCategory","Facility"],
      }),
      createIncomeCategory: builder.mutation<ApiResponse, IncomeCategoryType>({
        query: (incomeCategorydata) => ({
          url: `/income_category`,
          method: "POST",
          body: incomeCategorydata,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["IncomeCategory","Facility"],
      }),
      updateIncomeCategory: builder.mutation<ApiResponse, IncomeCategoryType>({
        query: (incomeCategorydata) => ({
          url: `/income_category/${incomeCategorydata.id}`,
          method: "PUT",
          body: incomeCategorydata,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["IncomeCategory","Facility"],
      }),
      deleteIncomeCategory: builder.mutation<ApiResponse, number>({
        query: (income_category_id) => ({
          url: `/income_category/${income_category_id}`,
          method: "DELETE",
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["IncomeCategory","Facility"],
      }),
      getIncomeCategoryById: builder.query<IncomeCategoryType, number>({
        query: (income_category_id) => ({
          url: `/income_category/${income_category_id}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["IncomeCategory","Facility"],
      }),
      getIncomeCategorList: builder.query<
        {
          id: number;
          name: string;
          sale_tax_id: number;
        }[],
        number
      >({
        query: (org_id) => ({
          url: `/income_category/list/`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["IncomeCategory","Facility"],
      }),
    };
  },
});

export const {
  useGetIncomeCategoryQuery,
  useCreateIncomeCategoryMutation,
  useUpdateIncomeCategoryMutation,
  useDeleteIncomeCategoryMutation,
  useGetIncomeCategoryByIdQuery,
  useGetIncomeCategorListQuery,
} = IncomeCategory;
